// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* NodeLayout 样式 */
.NodeLayout-container {
  position: relative; /* 为复制按钮定位做准备 */
  background: white;
  border: 2px solid #ddd;
  border-radius: 12px;
  padding: 16px;
  min-width: 200px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.NodeLayout-title {
  font-size: 12px;
  font-weight: 600;
  color: #666;
  margin-bottom: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-family: monospace;
}

.NodeLayout-content {
  /* 内容区域 */
}

.NodeLayout-handle {
  width: 12px;
  height: 12px;
  background: #667eea;
  border: 2px solid white;
  transition: all 0.2s ease;
}

.NodeLayout-handle:hover {
  width: 16px;
  height: 16px;
  border-width: 3px;
}

.NodeLayout-handle-input {
  background: #667eea;
  border-color: #667eea;
}

.NodeLayout-handle-output {
  background: #3b82f6;
  border-color: #3b82f6;
}

/* Handle 标签 */
.NodeLayout-handle-label {
  position: absolute;
  left: -70px;
  top: 50%;
  transform: translateY(-50%);
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
  color: white;
  padding: 6px 12px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  pointer-events: none;
  opacity: 0;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.25);
  border: 1px solid rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(8px);
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  letter-spacing: 0.025em;
  z-index: 100;
}

.NodeLayout-handle:hover .NodeLayout-handle-label {
  opacity: 1;
  transform: translateY(-50%) translateX(-2px);
  box-shadow: 0 6px 20px rgba(59, 130, 246, 0.35);
}

.NodeLayout-handle:hover .NodeLayout-handle-label::before {
  content: '';
  position: absolute;
  right: -4px;
  top: 50%;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-left: 4px solid #3b82f6;
  border-top: 4px solid transparent;
  border-bottom: 4px solid transparent;
  filter: drop-shadow(0 1px 2px rgba(59, 130, 246, 0.2));
}

.NodeLayout-handle-input .NodeLayout-handle-label {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.25);
}

.NodeLayout-handle-input:hover .NodeLayout-handle-label {
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.35);
}

.NodeLayout-handle-input:hover .NodeLayout-handle-label::before {
  border-left-color: #667eea;
  filter: drop-shadow(0 1px 2px rgba(102, 126, 234, 0.2));
}

/* 节点被选中时，一直显示标签 */
.react-flow__node.selected .NodeLayout-handle .NodeLayout-handle-label {
  opacity: 1;
  transform: translateY(-50%) translateX(-2px);
  box-shadow: 0 6px 20px rgba(59, 130, 246, 0.35);
}

.react-flow__node.selected .NodeLayout-handle-input .NodeLayout-handle-label {
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.35);
}

/* 标签出现动画 */
@keyframes NodeLayout-labelFadeIn {
  0% {
    opacity: 0;
    transform: translateY(-50%) translateX(-10px);
  }
  100% {
    opacity: 1;
    transform: translateY(-50%) translateX(-2px);
  }
}

.NodeLayout-handle:hover .NodeLayout-handle-label,
.react-flow__node.selected .NodeLayout-handle .NodeLayout-handle-label {
  animation: NodeLayout-labelFadeIn 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

/* 可点击的 Handle 标签 */
.NodeLayout-handle-label-clickable {
  pointer-events: auto;  /* 改为可交互 */
  cursor: pointer;       /* 显示手型光标 */
  user-select: none;     /* 禁止文本选择 */
}

/* 可点击标签的悬停效果 */
.NodeLayout-handle-label-clickable:hover {
  transform: translateY(-50%) translateX(-4px) scale(1.05);
  box-shadow: 0 8px 24px rgba(102, 126, 234, 0.45);
}

/* 可点击标签的按下效果 */
.NodeLayout-handle-label-clickable:active {
  transform: translateY(-50%) translateX(-2px) scale(0.98);
}

/* 添加点击提示图标 */
.NodeLayout-handle-label-clickable::after {
  content: ' +';
  font-weight: 700;
  margin-left: 4px;
  opacity: 0;
  transition: opacity 0.2s ease;
}

.NodeLayout-handle-label-clickable:hover::after {
  opacity: 1;
}

/* 复制按钮样式 */
.NodeLayout-duplicate-button {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 28px;
  height: 28px;
  border: 1px solid #ddd;
  border-radius: 6px;
  background: white;
  color: #666;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  transition: all 0.2s ease;
  opacity: 0;
  pointer-events: none;
  z-index: 10;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* 鼠标悬停在节点上时显示复制按钮 */
.NodeLayout-container:hover .NodeLayout-duplicate-button {
  opacity: 1;
  pointer-events: auto;
}

/* 复制按钮悬停效果 */
.NodeLayout-duplicate-button:hover {
  background: #f0f0f0;
  border-color: #3b82f6;
  color: #3b82f6;
  transform: scale(1.05);
}

/* 复制按钮点击效果 */
.NodeLayout-duplicate-button:active {
  transform: scale(0.95);
}

/* 节点被选中时，始终显示复制按钮 */
.react-flow__node.selected .NodeLayout-duplicate-button {
  opacity: 1;
  pointer-events: auto;
}

`, "",{"version":3,"sources":["webpack://./src/components/canvas/nodes/NodeLayout.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;EACE,kBAAkB,EAAE,eAAe;EACnC,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,cAAc;AACd;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,6DAA6D;EAC7D,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,UAAU;EACV,iDAAiD;EACjD,+CAA+C;EAC/C,0CAA0C;EAC1C,0BAA0B;EAC1B,yCAAyC;EACzC,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,4CAA4C;EAC5C,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,iCAAiC;EACjC,oCAAoC;EACpC,sDAAsD;AACxD;;AAEA;EACE,6DAA6D;EAC7D,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,0BAA0B;EAC1B,uDAAuD;AACzD;;AAEA,kBAAkB;AAClB;EACE,UAAU;EACV,4CAA4C;EAC5C,+CAA+C;AACjD;;AAEA;EACE,gDAAgD;AAClD;;AAEA,WAAW;AACX;EACE;IACE,UAAU;IACV,6CAA6C;EAC/C;EACA;IACE,UAAU;IACV,4CAA4C;EAC9C;AACF;;AAEA;;EAEE,mEAAmE;AACrE;;AAEA,mBAAmB;AACnB;EACE,oBAAoB,GAAG,UAAU;EACjC,eAAe,QAAQ,WAAW;EAClC,iBAAiB,MAAM,WAAW;AACpC;;AAEA,eAAe;AACf;EACE,wDAAwD;EACxD,gDAAgD;AAClD;;AAEA,eAAe;AACf;EACE,wDAAwD;AAC1D;;AAEA,aAAa;AACb;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,UAAU;EACV,oBAAoB;EACpB,WAAW;EACX,wCAAwC;AAC1C;;AAEA,oBAAoB;AACpB;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA,aAAa;AACb;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,sBAAsB;AACxB;;AAEA,aAAa;AACb;EACE,sBAAsB;AACxB;;AAEA,oBAAoB;AACpB;EACE,UAAU;EACV,oBAAoB;AACtB","sourcesContent":["/* NodeLayout 样式 */\n.NodeLayout-container {\n  position: relative; /* 为复制按钮定位做准备 */\n  background: white;\n  border: 2px solid #ddd;\n  border-radius: 12px;\n  padding: 16px;\n  min-width: 200px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.NodeLayout-title {\n  font-size: 12px;\n  font-weight: 600;\n  color: #666;\n  margin-bottom: 12px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  font-family: monospace;\n}\n\n.NodeLayout-content {\n  /* 内容区域 */\n}\n\n.NodeLayout-handle {\n  width: 12px;\n  height: 12px;\n  background: #667eea;\n  border: 2px solid white;\n  transition: all 0.2s ease;\n}\n\n.NodeLayout-handle:hover {\n  width: 16px;\n  height: 16px;\n  border-width: 3px;\n}\n\n.NodeLayout-handle-input {\n  background: #667eea;\n  border-color: #667eea;\n}\n\n.NodeLayout-handle-output {\n  background: #3b82f6;\n  border-color: #3b82f6;\n}\n\n/* Handle 标签 */\n.NodeLayout-handle-label {\n  position: absolute;\n  left: -70px;\n  top: 50%;\n  transform: translateY(-50%);\n  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);\n  color: white;\n  padding: 6px 12px;\n  border-radius: 16px;\n  font-size: 12px;\n  font-weight: 600;\n  white-space: nowrap;\n  pointer-events: none;\n  opacity: 0;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.25);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  backdrop-filter: blur(8px);\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n  letter-spacing: 0.025em;\n  z-index: 100;\n}\n\n.NodeLayout-handle:hover .NodeLayout-handle-label {\n  opacity: 1;\n  transform: translateY(-50%) translateX(-2px);\n  box-shadow: 0 6px 20px rgba(59, 130, 246, 0.35);\n}\n\n.NodeLayout-handle:hover .NodeLayout-handle-label::before {\n  content: '';\n  position: absolute;\n  right: -4px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 0;\n  height: 0;\n  border-left: 4px solid #3b82f6;\n  border-top: 4px solid transparent;\n  border-bottom: 4px solid transparent;\n  filter: drop-shadow(0 1px 2px rgba(59, 130, 246, 0.2));\n}\n\n.NodeLayout-handle-input .NodeLayout-handle-label {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.25);\n}\n\n.NodeLayout-handle-input:hover .NodeLayout-handle-label {\n  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.35);\n}\n\n.NodeLayout-handle-input:hover .NodeLayout-handle-label::before {\n  border-left-color: #667eea;\n  filter: drop-shadow(0 1px 2px rgba(102, 126, 234, 0.2));\n}\n\n/* 节点被选中时，一直显示标签 */\n.react-flow__node.selected .NodeLayout-handle .NodeLayout-handle-label {\n  opacity: 1;\n  transform: translateY(-50%) translateX(-2px);\n  box-shadow: 0 6px 20px rgba(59, 130, 246, 0.35);\n}\n\n.react-flow__node.selected .NodeLayout-handle-input .NodeLayout-handle-label {\n  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.35);\n}\n\n/* 标签出现动画 */\n@keyframes NodeLayout-labelFadeIn {\n  0% {\n    opacity: 0;\n    transform: translateY(-50%) translateX(-10px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(-50%) translateX(-2px);\n  }\n}\n\n.NodeLayout-handle:hover .NodeLayout-handle-label,\n.react-flow__node.selected .NodeLayout-handle .NodeLayout-handle-label {\n  animation: NodeLayout-labelFadeIn 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n/* 可点击的 Handle 标签 */\n.NodeLayout-handle-label-clickable {\n  pointer-events: auto;  /* 改为可交互 */\n  cursor: pointer;       /* 显示手型光标 */\n  user-select: none;     /* 禁止文本选择 */\n}\n\n/* 可点击标签的悬停效果 */\n.NodeLayout-handle-label-clickable:hover {\n  transform: translateY(-50%) translateX(-4px) scale(1.05);\n  box-shadow: 0 8px 24px rgba(102, 126, 234, 0.45);\n}\n\n/* 可点击标签的按下效果 */\n.NodeLayout-handle-label-clickable:active {\n  transform: translateY(-50%) translateX(-2px) scale(0.98);\n}\n\n/* 添加点击提示图标 */\n.NodeLayout-handle-label-clickable::after {\n  content: ' +';\n  font-weight: 700;\n  margin-left: 4px;\n  opacity: 0;\n  transition: opacity 0.2s ease;\n}\n\n.NodeLayout-handle-label-clickable:hover::after {\n  opacity: 1;\n}\n\n/* 复制按钮样式 */\n.NodeLayout-duplicate-button {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  width: 28px;\n  height: 28px;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  background: white;\n  color: #666;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  transition: all 0.2s ease;\n  opacity: 0;\n  pointer-events: none;\n  z-index: 10;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n/* 鼠标悬停在节点上时显示复制按钮 */\n.NodeLayout-container:hover .NodeLayout-duplicate-button {\n  opacity: 1;\n  pointer-events: auto;\n}\n\n/* 复制按钮悬停效果 */\n.NodeLayout-duplicate-button:hover {\n  background: #f0f0f0;\n  border-color: #3b82f6;\n  color: #3b82f6;\n  transform: scale(1.05);\n}\n\n/* 复制按钮点击效果 */\n.NodeLayout-duplicate-button:active {\n  transform: scale(0.95);\n}\n\n/* 节点被选中时，始终显示复制按钮 */\n.react-flow__node.selected .NodeLayout-duplicate-button {\n  opacity: 1;\n  pointer-events: auto;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
